<template>
    <nav class="app-sidebar d-flex flex-column border-end bg-white" :class="{ 'sidebar-open': isOpen }">
        <!-- Header -->
        <div class="p-3 border-bottom d-flex align-items-center gap-2">
            <div class="sidebar-logo rounded d-flex align-items-center justify-content-center bg-success text-white fw-bold"
                style="width: 28px; height: 28px; font-size: 13px;">
                G
            </div>
            <router-link to="/" class="text-decoration-none text-dark flex-grow-1">
                <span class="fw-semibold">Gestion</span>
            </router-link>
            <!-- Botón cerrar (solo mobile) -->
            <button class="btn btn-sm btn-light d-lg-none" @click="emit('close')" aria-label="Cerrar menú">
                <i class="bi bi-x fs-5" />
            </button>
        </div>

        <!-- Search -->
        <div class="px-2 py-2 border-bottom">
            <RouterLink to="/search" class="nav-link sidebar-link rounded d-flex align-items-center gap-2 px-2 py-2 text-dark" @click="emit('close')">
                <i class="bi bi-search" />
                <span>Buscar</span>
            </RouterLink>
        </div>

        <!-- Navigation -->
        <div class="flex-grow-1 py-2">
            <ul class="nav flex-column px-2" @click.capture="emit('close')">
                <li class="nav-item">
                    <RouterLink to="/" exact-active-class="router-link-active" active-class="" class="nav-link sidebar-link rounded d-flex align-items-center gap-2 px-2 py-2 text-dark">
                        <i class="bi bi-house" />
                        <span>Dashboard</span>
                    </RouterLink>
                </li>
                <li class="nav-item">
                    <RouterLink to="/mis-avisos" active-class="" :class="{ 'router-link-active': route.path.startsWith('/mis-avisos') }" class="nav-link sidebar-link rounded d-flex align-items-center gap-2 px-2 py-2 text-dark">
                        <i class="bi bi-bell" />
                        <span>Mis avisos</span>
                    </RouterLink>
                </li>
                <li class="nav-item">
                    <RouterLink to="/mi-agenda" active-class="" :class="{ 'router-link-active': route.path.startsWith('/mi-agenda') }" class="nav-link sidebar-link rounded d-flex align-items-center gap-2 px-2 py-2 text-dark">
                        <i class="bi bi-calendar3" />
                        <span>Mi agenda</span>
                    </RouterLink>
                </li>
                <li class="nav-item">
                    <RouterLink to="/mis-partes" active-class="" :class="{ 'router-link-active': route.path.startsWith('/mis-partes') }" class="nav-link sidebar-link rounded d-flex align-items-center gap-2 px-2 py-2 text-dark">
                        <i class="bi bi-file-text" />
                        <span>Mis partes</span>
                    </RouterLink>
                </li>
                <li class="nav-item">
                    <RouterLink to="/clientes" active-class="" :class="{ 'router-link-active': route.path.startsWith('/clientes') }" class="nav-link sidebar-link rounded d-flex align-items-center gap-2 px-2 py-2 text-dark">
                        <i class="bi bi-people" />
                        <span>Clientes</span>
                    </RouterLink>
                </li>
            </ul>
        </div>

        <!-- Bottom links -->
        <div class="py-2 border-top">
            <!-- User profile -->
            <div class="d-flex align-items-center gap-2 px-3 py-2">
                <div class="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center"
                    style="width: 28px; height: 28px; font-size: 12px; flex-shrink: 0;">
                    {{ initials }}
                </div>
                <span class="small text-truncate">{{ userName }}</span>
                <button class="btn btn-sm p-0 ms-auto text-muted" @click="logout" title="Sign out">
                    <i class="bi bi-box-arrow-right" />
                </button>
            </div>
        </div>
    </nav>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const route = useRoute()
const router = useRouter()

defineProps<{ isOpen: boolean }>()
const emit = defineEmits<{ close: [] }>()

const authStore = useAuthStore()

const userName = computed(() => authStore.userName)
const initials = computed(() => {
    return userName.value
        .split(' ')
        .slice(0, 2)
        .map((w) => w[0])
        .join('')
        .toUpperCase()
})

function logout() {
    authStore.logout()
}
</script>

<style scoped>
.app-sidebar {
    width: 240px;
    height: 100%;
}

/* Mobile: oculto por defecto, slide-in cuando está abierto */
@media (max-width: 991.98px) {
    .app-sidebar {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        z-index: 1045;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .app-sidebar.sidebar-open {
        transform: translateX(0);
    }
}

.sidebar-link:hover {
    background-color: var(--bs-gray-100);
}

.router-link-active.sidebar-link {
    background-color: var(--bs-gray-100);
    font-weight: 500;
}
</style>
